module.exports = __webpack_public_path__ + "img/ball_7.69b5e220.png";